import { Reveal } from '@/components/Reveal';
import { SectionHeading } from '@/components/SectionHeading';
import { SpotlightCard } from '@/components/SpotlightCard';

export function AboutPage(): JSX.Element {
  return (
    <div className="relative">
      <section className="relative py-24 md:py-32">
        <div className="absolute inset-0 -z-10 bg-grid opacity-30" />
        <div className="absolute inset-0 -z-10 bg-radial-mint" />

        <div className="max-w-4xl mx-auto px-5 md:px-8">
          <Reveal>
            <SectionHeading
              eyebrow="About · 关于速通"
              title={<>把学英语 <span className="text-gradient-warm">当一场速通来打</span></>}
              subtitle={'速通 = Speedrun。不绕远路、不背词表、不假装学习 — 用最直接的"听→说→拼→打"循环跑通语言的"主线剧情"。'}
            />
          </Reveal>

          <Reveal delay={0.1}>
            <div className="mt-14 space-y-6 text-cream-200/90 text-lg leading-relaxed">
              <p>
                我们也是被"语法书 + 词汇表 + 模拟卷"折磨过的人。后来明白一件事：
                <span className="text-white font-semibold">英语是练出来的，不是背出来的</span>。
              </p>
              <p>
                于是有了速通 — 把句子拆成可拖拽的拼图，把拼写做成键盘节奏游戏，
                把口语变成 0-100 分的发音挑战。每一次提交都有
                <span className="text-honey-300"> Perfect / Great / Good / Miss 实时评分</span>，
                每一次出错 AI 都会立刻帮你归档。
              </p>
              <p>
                <span className="text-honey-300">每一句课程内容都问过自己：值不值得占用你 5 秒钟。</span>
                81 个精选词单背后，是十几位资深英语老师对着真实考纲一句一句改出来的。
              </p>
              <p>
                目标只有一个：让你 3 个月里能脱口而出过去 3 年都说不出来的句子。
              </p>
            </div>
          </Reveal>

          <div className="mt-16 grid gap-6 md:grid-cols-3">
            {[
              { num: '120万+', label: '学员遍布全国' },
              { num: '4.8 / 5', label: 'App Store 评分' },
              { num: '95%', label: '坚持 30 天以上' },
            ].map((s, i) => (
              <Reveal key={s.label} delay={i * 0.06}>
                <SpotlightCard className="text-center">
                  <div className="font-display text-4xl font-extrabold text-gradient-honey">{s.num}</div>
                  <div className="mt-2 text-sm text-cream-400">{s.label}</div>
                </SpotlightCard>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
